import React from "react";

function Banner() {
  return (
    <div className="banner">
      <div className="banner-root"></div>
      <h1>A Love Story Written Just for You, Mitsuha ❤️ </h1>
    </div>
  );
}

export default Banner;
